import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function telatransmitecentral(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@telatransmitecentral/FIND':
      case '@telatransmitecentral/UPDATE':
      case '@telatransmitecentral/DELETE':
      case '@telatransmitecentral/STORE':
      case '@telatransmitecentral/IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@telatransmitecentral/SUCCESS_REMOVE':
      case '@telatransmitecentral/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@telatransmitecentral/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.telatransmitecentral;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@telatransmitecentral/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.telatransmitecentral;
        break;
      }

      case '@telatransmitecentral/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
